import { Form } from "react-bootstrap";

function DefaultColumnFilter({
  column: { filterValue, preFilteredRows, setFilter },
}: {
  column: any;
}) {
  const count = preFilteredRows.length;

  return (
    <Form.Control
      value={filterValue || ""}
      onChange={(e) => {
        setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
      }}
      placeholder={`Search ${count} records...`}
      className="mt-2"
    />
  );
}

export { DefaultColumnFilter };
